import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=38adee06&"
import script from "./FormText.vue?vue&type=script&lang=js&"
export * from "./FormText.vue?vue&type=script&lang=js&"
import style0 from "./FormText.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports